import React from 'react';

import InputRadioCollection from '../../../inputs/InputRadioCollection';
import InputText from '../../../inputs/InputText';
import InputSelect from '../../../inputs/InputSelect';
import InputCheckboxCollection from '../../../inputs/InputCheckboxCollection';
import InputError from '../../../inputs/InputError';
import ButtonPrimary from '../../../components/ButtonPrimary';

export default function Step1({
  className,
  values,
  errors,
  setValue,
  setDirty,
  nextStep,
  breeds,
  dietaryGoals,
  petTypes
}) {
  const setPetType = value =>
    setValue({ ...value, breed: '' });

  return (
  <section className={`share__step-1 ${ className || '' }`}>
    <div className="mb24">
      <InputRadioCollection
        name="petType"
        headingText="Pet Type"
        value={values.petType}
        setValue={setPetType}
        setDirty={setDirty}
        disableAutoComplete={true}
        radioOptions={petTypes}
      />
      <InputError hasError={errors.petTypeRequiredError}>Please select a pet type.</InputError>
    </div>
    {values.petType &&
    <>
      <div className="mb24">
        <InputSelect
          name="breed"
          value={values.breed}
          setValue={setValue}
          setDirty={setDirty}
          disableAutoComplete={true}
        >
          <option value="">Breed</option>
          {
            breeds
            .filter(({ petType }) => values.petType === petType._id)
            .map(({ _id, name }) => (
              <option key={_id} value={_id}>{name}</option>
            ))
          }
        </InputSelect>
        <InputError hasError={errors.breedRequiredError}>Please select a breed.</InputError>
      </div>
      <div className="mb24">
        <InputText
          name="petName"
          labelText="Pet's Name"
          value={values.petName}
          setValue={setValue}
          setDirty={setDirty}
          disableAutoComplete={true}
        />
        <InputError hasError={errors.petNameRequiredError}>Please enter the pet's name.</InputError>
      </div>
      <div className="mb24">
        <InputText
          name="petAge"
          labelText="Pet's Age"
          inputType="number"
          min={0}
          value={values.petAge}
          setValue={setValue}
          setDirty={setDirty}
          disableAutoComplete={true}
        />
        <InputError hasError={errors.petAgeFormatError}>Wrong format of the pet's age. Shouldn't be a negative or decimal.</InputError>
        <InputError hasError={errors.petAgeDirtyError}>Please enter the pet's age.</InputError>
      </div>
      <div className="mb24">
        <InputCheckboxCollection
          name="dietaryGoals"
          headingText="Dietary Goals"
          value={values.dietaryGoals}
          setValue={setValue}
          setDirty={setDirty}
          checkboxOptions={dietaryGoals}
          disableAutoComplete={true}
        />
      </div>
    </>
    }
    <div className="mb24 df jcfe">
      <ButtonPrimary onClick={nextStep}>
        Next
      </ButtonPrimary>
    </div>
    <InputError
      className="tar mb24"
      hasError={errors.petTypeRequiredError || errors.breedRequiredError || errors.petNameRequiredError }
    >
      This part of the form has errors.
    </InputError>
  </section>
  );
}
